import React from 'react';
import './slider-foamstop-pu-pyramiddesign.css';
import Pyramiddesign1 from '../../images/pyramid1.webp';
import Pyramiddesign2 from '../../images/pyramid2.webp';
function slider() {
	return (
	  
	<>
	<div id="slider-foamstop-pu-pyramiddesign">
		<div id="carouselExampleIndicators2" className="carousel slide" data-ride="carousel">
  			<ol className="carousel-indicators">
    			<li data-target="#carouselExampleIndicators2" data-slide-to="0" className="active"></li>
    			<li data-target="#carouselExampleIndicators2" data-slide-to="1"></li>
  			</ol>
  			<div className="carousel-inner">
    			<div className="carousel-item active">
      				<img className="d-block w-100" src={Pyramiddesign1} alt="Pyramiddesign1" />
	  				<div className="carousel-caption d-none d-md-block">
					  	<h1>PYRAMID DESIGN</h1>
					</div>
				</div>
    			<div className="carousel-item">
      				<img className="d-block w-100" src={Pyramiddesign2} alt="Pyramiddesign2" />
	  				<div className="carousel-caption d-none d-md-block">
					  	<h1>PYRAMID DESIGN</h1>
					</div>
				</div>
			</div>
  			<a className="carousel-control-prev" href="#carouselExampleIndicators2" role="button" data-slide="prev">
    			<span className="carousel-control-prev-icon" aria-hidden="true"></span>
    			<span className="sr-only">Previous</span>
  			</a>
  			<a className="carousel-control-next" href="#carouselExampleIndicators2" role="button" data-slide="next">
    			<span className="carousel-control-next-icon" aria-hidden="true"></span>
    			<span className="sr-only">Next</span>
  			</a>
		</div>
	</div>
	</>
);
}
export default slider;